import React, { FC } from 'react';
import translate from '@translate';
import { ReloadIcon } from 'src/components/SkladonIcon/Icons';
import TransportsSectionTopBlock from '../TransportsSection/TopBlock';
import SyncIcon from '@mui/icons-material/Sync';

interface TopBlockProps {
    reloadList: () => void;
    syncGeis: () => void;
    permissionSync: boolean;
}

const TopBlock: FC<TopBlockProps> = (props) => {
    return (
        <TransportsSectionTopBlock
            actions={[
                {
                    onClick: props.reloadList,
                    icon: <ReloadIcon />,
                    tooltip: translate('geisPackingTypes.action.reload'),
                    variant: 'outlined',
                },
                {
                    onClick: props.syncGeis,
                    icon: <SyncIcon />,
                    tooltip: translate('geisPackingTypes.action.sync'),
                    variant: 'outlined',
                    hidden: !props.permissionSync,
                    'data-testid': 'geis-packing-types-sync-btn',
                },
            ]}
        />
    );
};

export default TopBlock;
